import { useTranslation } from "@opendash/i18n";
import { Segmented } from "antd";
import React, { useEffect, useState } from "react";
export const TimeSeries = ({ value, onChange, onlyWeeks = false, }) => {
    const t = useTranslation();
    const [items, setItems] = useState([]);
    useEffect(() => {
        const itemsx = [];
        itemsx.push({
            label: t("maintenance:timeseries.pattern.radio.once"),
            value: "once",
        });
        if (!onlyWeeks) {
            itemsx.push({
                label: t("maintenance:timeseries.pattern.radio.daily"),
                value: "daily",
            });
        }
        itemsx.push({
            label: t("maintenance:timeseries.pattern.radio.weekly"),
            value: "weekly",
        });
        itemsx.push({
            label: t("maintenance:timeseries.pattern.radio.monthly"),
            value: "monthly",
        });
        itemsx.push({
            label: t("maintenance:timeseries.pattern.radio.yearly"),
            value: "yearly",
        });
        setItems(itemsx);
    }, [onlyWeeks]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Segmented, { options: items, value: value, onChange: (value) => {
                onChange(value);
            } })));
};
//# sourceMappingURL=TimeSeries.js.map